import React from 'react';
import styled from '@emotion/styled';
import { FieldCheckboxProps } from './types';

export const checkboxStyle = `input[type='checkbox'] {
  position: relative;
  width: 16px;
  height: 16px;
  margin-top: 0;
  margin-right: 11px;
  border: 1px solid #cccdcf;
  border-radius: 4px;
  background-color: #fff;
  -webkit-appearance: none;

  &:checked {
    background: #5000b9;
  }

  &::before {
    position: absolute;
    top: 1px;
    left: 4px;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    visibility: hidden;
    content: '';
  }

  &:checked::before {
    visibility: visible;
  }

  &:focus {
    border: 1px solid #5000b9;
    outline: 0;
  }

  &:disabled {
    border: 1px solid #cccdcf80;
    background-color: #ffffff00;
  }
}`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  color: #292f36;
  font-weight: normal;
  font-size: 0.875rem;
  &  ${checkboxStyle}
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const FieldCheckbox = React.forwardRef(
  (
    { label, name, containerClassName, ...rest }: FieldCheckboxProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <Container className={containerClassName}>
        <CheckboxLabel>
          <input ref={ref} {...rest} id={name} type="checkbox" name={name} />
          {label}
        </CheckboxLabel>
      </Container>
    );
  }
);

export { FieldCheckbox };
export { ControlledFieldCheckbox } from './ControlledFieldCheckbox';
